import StagePage from '../stage/StagePage';

export default function Round1Page() {
  return <StagePage stage={1} />;
}
